var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularArray20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 8.125,
    width: 2.5,
    height: 2.5,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 0.625,
    width: 2.5,
    height: 2.5,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 2.60727,
    width: 2.5,
    height: 2.5,
    transform: "rotate(45 14.375 2.60727)",
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.60727,
    y: 4.375,
    width: 2.5,
    height: 2.5,
    transform: "rotate(-45 2.60727 4.375)",
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.625,
    y: 8.125,
    width: 2.5,
    height: 2.5,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 12.6073,
    width: 2.5,
    height: 2.5,
    transform: "rotate(45 14.375 12.6073)",
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.125,
    y: 15.625,
    width: 2.5,
    height: 2.5,
    fill: "#222627",
    stroke: "#222627",
    strokeWidth: 1.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.0625,
    y: 9.0625,
    width: 0.625,
    height: 0.625,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularArray20);
export default __webpack_public_path__ + "static/media/circular-array_20.928958e7f7142c7ed97feeccc8d9301d.svg";
export { ForwardRef as ReactComponent };